export const DRAGGING_START_NODE = 'DRAGGING_START_NODE';
export const DRAGGING_END_NODE = 'DRAGGING_END_NODE';
export const DRAWING_WALL = 'DRAWING_WALL';
export const DRAWING_TREE = 'DRAWING_TREE';
export const GRID_ROWS = 17;
export const GRID_COLUMNS = 40;
export const DEFAULT_START_NODE = {
    row: 9,//7
    column: 10,//10
};
export const DEFAULT_END_NODE = {
    row: 9,//7
    column: 30,//30
};
export const SOLUTION_SPEED = 50;//fast 1 10 30 50 100 slow
export const PATH_SPEED = 35;
export const ALGORITHMS = [{ abbreviation: 'BFS', name: 'Breath-first Search' }, { abbreviation: 'DFS', name: 'Depth-first Search' }, { abbreviation: 'DIJ', name: "Dijkstra's Algorithm" }];
export const SQUARE_COST = 1;
export const TREE_COST = 5;